// extracted by mini-css-extract-plugin
export var statItem = "_go-1";
export var statsRow = "_go-0";